import { Card, CardContent } from "@/components/ui/card";

/** Friendly empty state: icon + title + optional hint, theme-aware. */
const EmptyState = ({ icon: Icon, title, hint, testId }) => (
  <Card data-testid={testId}>
    <CardContent style={{ padding: '3.5rem 2rem', textAlign: 'center' }}>
      {Icon && (
        <Icon
          className="w-10 h-10"
          style={{ margin: '0 auto 1rem', display: 'block', color: 'hsl(var(--muted-foreground))', opacity: 0.6 }}
        />
      )}
      <p style={{ fontWeight: 600, marginBottom: '0.35rem' }}>{title}</p>
      {hint && <p style={{ fontSize: '0.9rem', color: 'hsl(var(--muted-foreground))' }}>{hint}</p>}
    </CardContent>
  </Card>
);

export default EmptyState;
